import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { MegaTagTitle } from 'components/Elements'
import { PageContent } from 'components/Layouts'
import { SentInvitesContainer } from 'features/job-invite/components/Invites/SentInvites'

export const Invites = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'candidate_invites'} />

      <PageContent>
        <SentInvitesContainer />
      </PageContent>
    </>
  )
}

Invites.propTypes = {}
